// extracted by mini-css-extract-plugin
export default {"nav":"styles_nav__V1cD8","items":"styles_items__eDdip","navItem":"styles_navItem__6LDGG","navIcon":"styles_navIcon__R+6lM","chevron":"styles_chevron__cznvw"};